import { render, staticRenderFns } from "./EVMTransaction.vue?vue&type=template&id=48141335&scoped=true&"
import script from "./EVMTransaction.vue?vue&type=script&lang=ts&"
export * from "./EVMTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./EVMTransaction.vue?vue&type=style&index=0&id=48141335&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48141335",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
